<template>
  <div class="malls">
    <adx-category-page :title="title" :collection="collections">
      <template slot="filter">
          <adx-dropdown-checkbox v-if="surroundings.length" @selected="selectedSurrounding" :color="'pink'"
          :list="surroundings"
          labelButton="Surrounding"
          :title="`Surrounding`" :default="selectedSurroundingValue" />
          <adx-dropdown-checkbox v-if="social.length" @selected="selectedSocial" :color="'pink'"
          :list="social"
          labelButton="Social"
          :title="`Social`" :default="selectedSocialValue" />
          <adx-dropdown-checkbox v-if="profile.length" @selected="selectedProfile" :color="'pink'"
          :list="profile"
          labelButton="Profile"
          :title="`Profile`" :default="selectedProfileValue" />
        <adx-dropdown-list class="sort-mobile" @selected="selectedSort" :color="'pink'" :list="sort" labelButton="Sort by" :title="`Sort by`" />
        <adx-dropdown-list class="quick-filter-mobile" @selected="selectedCity" :color="'pink'" :list="cities" labelButton="Locations" :title="`Locations`" :valueDisplay="selectedCityValue"/>
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset Filter</button>
        </div>
      </template>
      <template slot="sort">
        <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sort" />
      </template>
      <template slot="collection">
        <div v-if="isLoadingCol" class="colloading">
          <adx-loading slot="loading" />
        </div>
        <div v-else>
          <adx-collection-slider :slide="6" :slideMobile="2" :data="collections" />
        </div>
      </template>
      <template slot="listitem">
        <adx-list-items 
        @createNew="createNew" 
        @item-clicked="gotoDetail($event)" 
        :isAction="true" :menuList="expansionList" 
        :category="`daily`" 
        :items='items' 
        :page="count" 
        :headers='listheaders' 
        :loading="isLoading" 
        @createNewCampaign="createNewCampaign">
        <template slot="infiniteLoading">
            <template v-if="!isLoading">
              <div v-if="next" class="malls__paging" @click.stop="loadData">
                <span class="malls__paging__load">Show more</span>
              </div>
              <p v-else-if="items.length && !next">There is no more data</p>
            </template>
            <template v-else>

              <adx-loading v-if="isLoading" slot="loading" />
            </template>
          </template>
      </adx-list-items>
      <!-- Pagination -->
      <!-- <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" 
      :maxPage="maxPage" @change-page="selectPage"/></div> -->
      <!-- Loading State -->
      <!-- <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div> -->
      <!-- Empty State -->
      <!-- <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div> -->
      </template>
      <template slot="quickfilter">
        <adx-quick-filter :list="cities" :value.sync="selectedCityValue" />
      </template>
    </adx-category-page>
    <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="toggleModalCreate" type='small' :noTitle="true">
      <div class="malls__modal" slot="content">
        <div class="malls__modal__input">
          <input ref="input" type="text" :class="{error: maxSavedTitleError}" v-model="savedTitle" @keyup="KeyUp">
          <label class="subhead">Folder Name</label>
        </div>
        <span v-if="maxSavedTitleError" class="small-font saved-title-error">Ensure this field has no more than 191 characters.</span>
        <div class="malls__modal__buttons">
          <button class="btn-regular secondary" @click="toggleModalCreate">Cancel</button>
          <button class="btn-regular primary" :disabled="newTitle === '' || maxSavedTitleError"
          @click="createFolder">Save</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
      <div class="malls__modal" slot="content">
        <div class="malls__modal__input">
          <input ref="input" type="text" @keyup="KeyUpCampaign">
          <label class="subhead">Campaign Name</label>
        </div>
        <div class="malls__modal__buttons">
          <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
          <button class="btn-regular primary" :disabled="newTitle === ''"
          @click="createCampaign">Save</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
//Components
import CategoryPage from '@/components/Page/Category'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import CollectionSlider from '@/components/Slider/CardSlider'
import ListItems from '@/components/ListItemsV2'
import QuickFilter from '@/components/QuickFilter'
import Loading from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'

//Library
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { experienceParams } from '@/api/params'
import { fromKeys } from '@/lib/transformer'
import types from '@/lib/types'
import InfiniteLoading from 'vue-infinite-loading'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-malls',
  components: {
    'adx-category-page': CategoryPage,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'adx-collection-slider': CollectionSlider,
    'adx-list-items': ListItems,
    'adx-quick-filter': QuickFilter,
    'infinite-loading': InfiniteLoading,
    'adx-loading': Loading,
    'adx-modal': Modal,
    'adx-pagination': Pagination
  },
  head: {
    title: {
      inner: 'Malls',
    }
  },
  data(){
    return {
      title: 'Experience Branding in Malls',
      items: [],
      isLoading: false,
      isLoadingCol: true,
      collectionTitle: '',
      collectionDesc: '',
      next: null,
      count: null,
      page: 1,
      isCreateCampaign: false,
      isCreateSaved: false,
      newTitle: '',
      createParams: {},
      locations: [],
      selectedLocationValue: '',
      sort: types.deviceOrdering,
      selectedSortValue: types.deviceOrdering[1].value,
      collections: [],
      expansionList: [],
      listheaders: [
        'items',
        'placement',
        'daily traffic',
        'price / day'
      ],
      cities: [],
      selectedCityValue: '',
      surroundings: [],
      selectedSurroundingValue: [],
      social:[],
      selectedSocialValue: [],
      profile:[],
      selectedProfileValue: [],
      savedTitle: '',
      maxSavedTitleError: false,
      selectedPage: 1,
      maxPage: 0,
      isEmpty: false
    }
  },
  beforeMount () {
    this.getFilter()
  },
  mounted () {
    this.loadSavedandCampaign()
    const query = this.$route.query
    if (query) {
      setTimeout(() => {
        this.setFilterQuery(query)
        this.resetPageState()
        this.initalLoad()
      }, 100);
    } else {
      this.initalLoad(`initial`)
    }

    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initalLoad()
  },
  watch: {
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedCityValue: function () {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.resetPageState()
        this.initalLoad()
      });
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort_by' && querys[key]) filtered = true
      });

      if (
        this.selectedTypeValue ||
        this.selectedSurroundingValue.length ||
        this.selectedSocialValue.length ||
        this.selectedProfileValue.length 
      ) filtered = true

      return filtered
    },
    getFilterParams: function () {
      const params = {
        sort_by: this.selectedSortValue || undefined,
        surrounding: this.selectedSurroundingValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        city: this.selectedCityValue || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    ...mapGetters({
      defaultSaved: 'defaultSaved',
      token: 'token'
    })
  },
  methods: {
    getCollections() {
      (async () => {
        this.isLoadingCol = true
        const { data } = await api.get(apiV2.collectionAdvertiserList('malls'), { needToken: false })
        data.data.map(col => {
          let temp = []
          col.list.slice(0, 6).map(item => {
            temp.push({
              id: item.id,
              img: item.square_image,
              title: item.title,
              description: item.description
            })
          })
          if (col.layout_id == 'RE') {
            this.collections = temp
            this.collectionTitle = col.title
            this.collectionDesc = col.description
          }
        })
        this.isLoadingCol = false
      })();
    },
    loadSavedandCampaign() {
      this.expansionList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        if (this.token) {
          const response = await api.get(apiV2.saved, { needToken: true })
          if (response.status === 200) {
            const { data } = response
            data.map(el => {
              if (el.id !== this.defaultSaved) {
                this.expansionList[0]['items'].push({
                  "name": el.title,
                  "value": el.id
                })
              }
            })
          }
        }
      })();
    },
    loadCampaigns() {
      (async () => {
        if (this.token) {
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          if (response.status == 200) {
            const { data } = response
            data.map(el => {
              this.expansionList[1]['items'].push({
                "name": el.title,
                "value": el.id
              })
            })
          } else {
            // this.error = response.data.error
          }
        }
      })();
    },
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    createNewCampaign(params) {
      this.createParams = params
      if (this.token) {
        this.isCreateCampaign = true
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.name }})
      }
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    setFilterQuery (query) {
      Object.keys(query).map((index, element) => {
        const variable = types.deviceFilter[index]
        this.$data[variable] = ( () => {
          switch (variable) {
            case `selectedSortValue`:
            case `selectedCityValue`:
              return query[index]
              break
            default:
              return query[index].split(`,`)
          }
        })()
      })
    },
    selectedSurrounding(item){
      this.selectedSurroundingValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedProfile(item){
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSocial(item){
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedCity(item){
      this.selectedCityValue = item.value
      this.$nextTick(() => {
        this.resetPageState()
        this.initalLoad()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `name`
      } else {
        this.selectedSortValue = item.value
      }
    },
    resetPageState () {
        this.$data.items = []
        this.$data.count = null
        this.$data.page = 1
        this.$data.next = null
        // this.$refs.InfiniteLoadingRefs.stateChanger.reset()
    },
    selectPage(item) {
      this.selectedPage = item
      this.initialLoad()
    },
    initalLoad(isInit = null){
      (async () => {
        this.$data.isLoading = true
        const categoryName = this.$options.name.split(`-`).pop()
        let params = {
          ...experienceParams[categoryName],
          page: this.selectedPage,
          ...this.getFilterParams
        }
        this.isEmpty = false
        const { data } = await api.get(apiV2.experienceBranding, { params })

        if (!data.count) {
          this.isEmpty = true
        }
        this.maxPage = data.max_page
        this.count = data.count
        this.items = data.results
        this.next = isInit
        if (data.next) {
          this.next = data.next
        }
        this.getFilter()
        this.$data.isLoading = false
      })();
    },
    async loadData($state) {
      const categoryName = this.$options.name.split(`-`).pop()
      if (this.$data.next) {
        this.$data.isLoading = true
        let params = {
          ...experienceParams[categoryName],
          page: this.$data.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.experienceBranding, { params })
        if (data.results) {
          this.$data.items = this.$data.items.concat(data.results)
          this.$data.count = data.count
          this.$data.next = data.next
        } else {

        }
        this.$data.page += 1
        this.$data.isLoading = false
      }
    },
    getFilter () {
      (async () => {
        const categoryName = this.$options.name.split(`-`).pop()
        const { data } = await api.get(apiV2.experienceBrandingFilter, { params: experienceParams[categoryName] })
        this.mapFilter(data)
      })();
    },
    mapFilter (data) {
      this.surroundings = fromKeys(data.surrounding)
      this.social = data.social.map(social => {
        return {
          id: social.id,
          label: social.title,
          value: social.level
        }
      })
      this.profile = data.profile.map(el => {
        return {
          id: el.id,
          label: el.name,
          value: el.id
        }
      })
      this.cities = []
      data.cities.map(city => {
        this.cities.push({
          id: city.id,
          label: city.title,
          value: city.id
        })
      })
    },
    gotoDetail(item) {
      if (item.pub_id) {
        const { pub_id } = item
        let route = this.$router.resolve({name: 'experiencemallsdetail', params: {pub_id}});
        window.open(route.href, '_blank');
      }
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    createNew(params) {
      this.createParams = params
      if (this.token) {
        this.isCreateSaved = true
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.name }})
      }
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.loadSavedandCampaign()
        }
      })();
    },
    toggleModalCreate() {
      this.isCreateSaved = !this.isCreateSaved
    },
    resetFilter() {
      this.selectedCityValue = ''
      this.selectedSurroundingValue = []
      this.selectedProfileValue = []
      this.selectedSocialValue = []

      const params = {
        brand: undefined,
        location: undefined,
        city: undefined
      }
      this.$router.replace({
        query: params
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>